import "sanitize.css";
import Vue from "vue";
import { VueHammer } from "vue2-hammer";
import App from "./App.vue";
import "./directives/onResize";
import router from "./router";
import store from "./store";

Vue.config.productionTip = false;

/**
 * @see {@link https://bit.ly/3f2WCPe} VueHammer vertical scroll issue with swipe
 * @see {@link https://bit.ly/3g3PHH9} VueHammer multiple swipe bindings issue
 */
Vue.use(VueHammer);
VueHammer.config.swipe = {
  direction: 6,
};

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount("#app");
